import React, { Component } from 'react';
// import AwardsComponent from './../components/awards';
// import * as api from '../api'

export default class OuterNewUser extends Component {
  constructor(props) {
    super (props)
    this.state = {
      isShow: false
    }
  }

  _handleJoin() {
    const {joinGameCallback} = this.props
    joinGameCallback({isJoin: true})
  }

  render() {
    return (
      <div className='main_info'>
        <div className="firendlyTip">
          <p>恭喜你！获得 1 次免费抢红包的机会！</p>
        </div>
        <div className="splitLine"></div>
        <p className='newUser'>新用户99.9% 中奖！</p>
        <div className='btn yellow' clstag="jr|keycount|yqsbhby|23" onClick={this._handleJoin.bind(this)}>马上参与</div>
      </div>
    )
  }
}